import React from 'react';
import { FilterDateRange } from '@bit/knotchinc.web-react-components.date-filter';
import {
  DateContainer,
  InputLabel } from './styled';

const SearchDateInput = ({ label, onUpdate, themed }) => <React.Fragment>
  <InputLabel>{label}</InputLabel>
  <div className="filters">
    <DateContainer>
      <FilterDateRange update={onUpdate} themed={themed} />
    </DateContainer>
  </div>
</React.Fragment>;

export default SearchDateInput;
